(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[178],{

/***/ 3308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7379);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2317);
/* harmony import */ var images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3017);
/* harmony import */ var images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_3__);





function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 0;\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n  max-width: 350px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 0 0.8rem;\n  background: ",
        ";\n  .exclamationPoint {\n    position: absolute;\n    left: 10px;\n    width: 100%;\n    max-width: 19px;\n    height: 18px;\n    padding: 0;\n    margin: 0;\n    background: url(",
        ") no-repeat;\n  }\n  .messageText {\n    color: ",
        ";\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ErrorBanner = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledErrorBanner, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "exclamationPoint"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "messageText",
                children: "Invalid activation code. Please try again."
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorBanner);
var StyledErrorBanner = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-ff3ac6ce-0"
})(_templateObject(), styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .fox.Monza */ .vn.Monza, (images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_3___default()), styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].white */ .ZP.white);


/***/ }),

/***/ 5714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_RegCodeInput; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
// EXTERNAL MODULE: ./styles/animations.ts
var animations = __webpack_require__(3167);
// EXTERNAL MODULE: ./styles/helper.ts + 1 modules
var helper = __webpack_require__(9900);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 8 modules
var hooks = __webpack_require__(9434);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
;// CONCATENATED MODULE: ./validations/schemas/RegCodeSchema.ts

// eslint-disable-next-line @typescript-eslint/no-var-requires
var yupResolver = (__webpack_require__(5496)/* .yupResolver */ .X);
var RegCodeSchema = function() {
    return yupResolver(es/* object */.Ry().shape({
        regCode: es/* string */.Z_().nullable().required('Reg code is required').min(4, 'Min length is 4 characters')
    }).required());
};
/* harmony default export */ var schemas_RegCodeSchema = (RegCodeSchema);

// EXTERNAL MODULE: ./context/GlobalContextProvider.tsx
var GlobalContextProvider = __webpack_require__(1387);
// EXTERNAL MODULE: ./components/common/index.tsx + 6 modules
var common = __webpack_require__(2513);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./context/state/reducer.ts + 1 modules
var reducer = __webpack_require__(2807);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var utils_helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/analytics/trackCalls.ts + 1 modules
var trackCalls = __webpack_require__(5537);
// EXTERNAL MODULE: ./lib/hooks/useFlowManager.ts
var useFlowManager = __webpack_require__(9697);
;// CONCATENATED MODULE: ./components/RegCodeInput/hooks.ts










function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useRegCodeInput = function(param) {
    var profile = param.profile, setRegCodeError = param.setRegCodeError;
    var dispatch = (0,react.useContext)(GlobalContextProvider/* AppContext */.I).dispatch;
    var ref = (0,react.useState)(''), regCode1 = ref[0], setRegCode = ref[1];
    var ref1 = (0,hooks/* useBoolean */.kt)(false), error = ref1.value, setErrorTrue = ref1.setTrue, setErrorFalse = ref1.setFalse;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,useFlowManager/* default */.Z)(), cookies = ref2.cookies, setCookie = ref2.setCookie, removeCookie = ref2.removeCookie;
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(regCode) {
            var response, firstScreenDeviceId, isAnonymous, isMvpd, isRegister, info, account, account1, info1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setErrorFalse();
                        setRegCodeError(false);
                        removeCookie(constants/* COOKIE_CODE_INFO */.r5);
                        ;
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return profile.validateRegCode(regCode);
                    case 7:
                        response = _ctx.sent;
                        firstScreenDeviceId = response.firstScreenDeviceId, isAnonymous = response.isAnonymous, isMvpd = response.isMvpd, isRegister = response.isRegister;
                        info = _objectSpread({
                            code: regCode,
                            deviceId: (0,utils_helper.uuidv4)(),
                            type: constants/* CODE_TYPE_API */.Mp
                        }, response);
                        setRegCode(regCode);
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.PROFILE_INITIATED */.zW.PROFILE_INITIATED,
                            props: {
                                page_activation_code: regCode
                            }
                        });
                        if (!("fox" === constants/* Brand.NATION */.H2.NATION)) {
                            _ctx.next = 27;
                            break;
                        }
                        setCookie(constants/* COOKIE_CODE_INFO */.r5, info, {
                            path: '/'
                        });
                        _ctx.next = 16;
                        return profile.loginAnonymously(firstScreenDeviceId);
                    case 16:
                        account = _ctx.sent;
                        (0,utils_helper.setAccountCookie)(account);
                        if (!isMvpd) {
                            _ctx.next = 24;
                            break;
                        }
                        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_MVPD_SELECT */.Vr));
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
                            props: {
                                page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                                page_destination_url: window.location.origin + constants/* ROUTE_MVPD */.W3
                            }
                        });
                        _ctx.next = 23;
                        return router.push(constants/* ROUTE_MVPD */.W3);
                    case 23:
                        return _ctx.abrupt("return");
                    case 24:
                        if (!isAnonymous) {
                            _ctx.next = 27;
                            break;
                        }
                        window.location.href = "".concat((0,utils_helper.displayNationAccountEnvURL)(), "?code=").concat(regCode);
                        return _ctx.abrupt("return");
                    case 27:
                        setCookie(constants/* COOKIE_CODE_INFO */.r5, info, {
                            path: constants/* ROUTE_HOME */.XX
                        });
                        dispatch((0,reducer/* setCodeInfo */.ys)(cookies[constants/* COOKIE_CODE_INFO */.r5]));
                        // Now & Sports flow
                        if (isRegister) dispatch((0,reducer/* setIsRegister */.ko)(isRegister));
                        if (!isMvpd) {
                            _ctx.next = 41;
                            break;
                        }
                        _ctx.next = 33;
                        return profile.loginAnonymously(firstScreenDeviceId);
                    case 33:
                        account1 = _ctx.sent;
                        (0,utils_helper.setAccountCookie)(account1);
                        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_MVPD_SELECT */.Vr));
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
                            props: {
                                page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                                page_destination_url: window.location.origin + constants/* ROUTE_MVPD */.W3
                            }
                        });
                        _ctx.next = 39;
                        return router.push(constants/* ROUTE_MVPD */.W3);
                    case 39:
                        _ctx.next = 46;
                        break;
                    case 41:
                        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_PROFILE_AUTH */.T7));
                        // remove Anonymous Account Cookie to go get a Profile Account cookie
                        removeCookie(constants/* ACCOUNT_COOKIE_NAME_FOX */.EO);
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
                            props: {
                                page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                                page_destination_url: window.location.origin
                            }
                        }, {
                            eventName: trackCalls/* Events.SUBMIT_CODE_COMPLETED */.zW.SUBMIT_CODE_COMPLETED,
                            props: {
                                page_active_code: regCode
                            }
                        });
                        _ctx.next = 46;
                        return router.push(constants/* ROUTE_ACCOUNT */.I);
                    case 46:
                        _ctx.next = 57;
                        break;
                    case 48:
                        _ctx.prev = 48;
                        _ctx.t0 = _ctx["catch"](4);
                        dispatch((0,reducer/* setError */.sT)(_ctx.t0));
                        dispatch((0,reducer/* setIsRegister */.ko)(false));
                        info1 = _objectSpread({
                            code: regCode
                        }, response);
                        setCookie(constants/* COOKIE_CODE_INFO */.r5, info1, {
                            path: constants/* ROUTE_HOME */.XX
                        });
                        setRegCodeError(true);
                        setErrorTrue();
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
                            props: {
                                page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                                page_destination_url: window.location.origin
                            }
                        }, {
                            eventName: trackCalls/* Events.PROFILE_ACCESS_ACTIVATION_ERROR */.zW.PROFILE_ACCESS_ACTIVATION_ERROR,
                            props: {
                                page_activation_code: regCode,
                                page_error_description: 'no error description',
                                page_error_type: 'invalid form input'
                            }
                        });
                    case 57:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    48
                ]
            ]);
        }));
        return function handleSubmit(regCode) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        regCode: regCode1,
        setRegCode: setRegCode,
        handleSubmit: handleSubmit,
        error: error
    };
};
/* harmony default export */ var RegCodeInput_hooks = (useRegCodeInput);

;// CONCATENATED MODULE: ./components/RegCodeInput/index.tsx














function RegCodeInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RegCodeInput_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RegCodeInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RegCodeInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function RegCodeInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RegCodeInput_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RegCodeInput_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      width: 200px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  input {\n    text-transform: uppercase;\n    padding: 0;\n    ",
        "\n    &:focus,\n    :active {\n      border: solid 2px ",
        ";\n    }\n    &::placeholder {\n      color: ",
        ";\n      text-transform: initial;\n      opacity: 0.5;\n    }\n    &.error {\n      border: solid 2px ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var RegCodeInput = function(param) {
    var profile = param.profile, setRegCodeError = param.setRegCodeError;
    var ref5 = (0,react.useContext)(GlobalContextProvider/* AppContext */.I), error = ref5.state.error;
    var ref1 = RegCodeInput_hooks({
        profile: profile,
        setRegCodeError: setRegCodeError
    }), handleSubmitRegCode = ref1.handleSubmit;
    var isNation = (0,hooks/* useFlowManager */.ix)().isNation;
    var ref2 = (0,react.useState)(), qrCode = ref2[0], setQrCode = ref2[1];
    var ref3 = (0,react.useState)(false), isQrCode = ref3[0], setIsQrCode = ref3[1];
    (0,react.useEffect)(function() {
        var ref;
        if (location === null || location === void 0 ? void 0 : (ref = location.pathname) === null || ref === void 0 ? void 0 : ref.startsWith(constants/* PATH_ACTIVATE */.rr)) {
            var arr = location === null || location === void 0 ? void 0 : location.href.split('/').filter(function(str) {
                return str;
            });
            var code = arr[(arr === null || arr === void 0 ? void 0 : arr.indexOf('activate')) + 1];
            setQrCode(code);
            if (code) setIsQrCode(true);
        }
    }, []);
    var ref4 = (0,index_esm/* useForm */.cI)({
        mode: 'onChange',
        reValidateMode: 'onSubmit',
        resolver: schemas_RegCodeSchema()
    }), register = ref4.register, handleSubmit = ref4.handleSubmit, isValid = ref4.formState.isValid;
    var onSubmit = function() {
        var _ref = RegCodeInput_asyncToGenerator(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleSubmitRegCode(data.regCode.toUpperCase());
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var disable = function() {
        if (isQrCode) {
            return false;
        }
        return !isValid;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Input */.II, RegCodeInput_objectSpread({}, register('regCode', {
                    required: true
                }), {
                    placeholder: "Activation Code",
                    autoCapitalize: "on",
                    type: "text",
                    autoFocus: true,
                    className: error ? 'error' : '',
                    defaultValue: qrCode
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                    kind: isNation ? 'secondary' : 'default',
                    type: "submit",
                    disabled: disable(),
                    children: "Submit"
                })
            ]
        })
    }));
};
/* harmony default export */ var components_RegCodeInput = (RegCodeInput);
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-3206b154-0"
})(_templateObject1(), animations/* fadein */.jF, helper/* respondTo.bp_768 */.s.bp_768(_templateObject()), colors/* fox.azureRadiance */.vn.azureRadiance, colors/* default.white */.ZP.white, colors/* default.error */.ZP.error);


/***/ }),

/***/ 5537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zW": function() { return /* binding */ Events; },
  "sn": function() { return /* binding */ PageNames; },
  "c7": function() { return /* binding */ PageTypes; },
  "Vk": function() { return /* binding */ handleAccountPageEvent; },
  "qH": function() { return /* binding */ handleHomePageEvent; },
  "GV": function() { return /* binding */ handleTrackEvent; },
  "jV": function() { return /* binding */ mountDataLayer; },
  "l9": function() { return /* binding */ setPageAnalyticsData; }
});

// UNUSED EXPORTS: EventTypes, generatePageName

// EXTERNAL MODULE: ./node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(5501);
// EXTERNAL MODULE: ./lib/analytics/segment/index.ts + 2 modules
var segment = __webpack_require__(4292);
;// CONCATENATED MODULE: ./lib/analytics/index.ts

var initiated = false;
var LCP_TIME = 6000;
var init = function() {
    window.segmentFlushQueue = flushQueue;
    if (initiated) return true;
    initSegment();
    initiated = true;
    window.addEventListener('unload', function() {
        flushQueue();
    });
    return initiated;
};
var handleAnalytics = function(event) {
    (0,segment/* segmentTrackEvent */.R7)(event);
};
var timedOutInit = function() {
    if (initiated) return true;
    setTimeout(function() {
        return init();
    }, LCP_TIME);
    return true;
};

// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/utils/getConfig.ts + 1 modules
var getConfig = __webpack_require__(889);
;// CONCATENATED MODULE: ./lib/analytics/trackCalls.ts





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var EventTypes;
(function(EventTypes) {
    EventTypes["PAGE"] = 'page';
    EventTypes["TRACK"] = 'track';
})(EventTypes || (EventTypes = {}));
var Events;
(function(Events) {
    Events["BUTTON_LINK_SELECTED"] = 'Button Link Selected';
    Events["SUBMIT"] = 'Submit';
    Events["SUBMIT_CODE_LANDING"] = 'Submit Code Landing';
    Events["SUBMIT_CODE_STARTED"] = 'Submit Code Started';
    Events["SUBMIT_CODE_COMPLETED"] = 'Submit Code Completed';
    Events["PROFILE_ACCESS_ACTIVATION_STARTED"] = 'Profile Access Activation Started';
    Events["PROFILE_ACCESS_ACTIVATION_COMPLETED"] = 'Profile Access Activation Completed';
    Events["PROFILE_ACCESS_ACTIVATION_ERROR"] = 'Profile Access Activation Error';
    Events["PROFILE_INITIATED"] = 'Profile Initiated';
    Events["PROFILE_PROMPT_LANDING"] = 'Profile Prompt Landing';
    Events["PROFILE_SIGN_IN_STARTED"] = 'Profile Sign In Started';
    Events["PROFILE_SIGN_UP_STARTED"] = 'Profile Sign Up Started';
    Events["PROFILE_SIGN_IN_COMPLETED"] = 'Profile Sign In Completed';
    Events["PROFILE_SIGN_UP_COMPLETED"] = 'Profile Sign Up Completed';
})(Events || (Events = {}));
var FOX_PREFIX = 'delta';
var NATION_PREFIX = 'nation';
var SPORT_PREFIX = 'nation sport';
var PageNames;
(function(PageNames) {
    PageNames["SUBMIT_CODE_LANDING"] = 'submit code landing';
    PageNames["PROFILE_PROMPT_LANDING"] = 'profile prompt:landing';
})(PageNames || (PageNames = {}));
var PageTypes;
(function(PageTypes) {
    PageTypes["ACTIVATION_CODE"] = 'activation code';
    PageTypes["PROFILE_PROMPT"] = 'profile prompt';
})(PageTypes || (PageTypes = {}));
var _obj;
var getClientPrefix = (_obj = {}, _defineProperty(_obj, constants/* Brand.FOX */.H2.FOX, FOX_PREFIX), _defineProperty(_obj, constants/* Brand.SPORTS */.H2.SPORTS, SPORT_PREFIX), _defineProperty(_obj, constants/* Brand.NATION */.H2.NATION, NATION_PREFIX), _obj);
var ACTIVATION_METHOD = '2nd screen';
var APP_PLATFORM = 'web';
var FOX = 'fox';
var FOX_DOMAIN = 'fox.com';
var NATION_DOMAIN = 'foxnews.com';
var ANONYMOUS_ID_COOKIE = 'lastAnonymousProfileId';
var PAGE_TYPE = 'ott';
var PRIMARY_BUSINESS_UNIT = 'fng';
var PROFILE_ID_COOKIE = 'secondScreenProfileId';
var START_SOURCE = 'general';
var APP_CLIENT_PREFIX = getClientPrefix["fox"];
var defaultTraits = {
    appsflyer_id: '',
    dcg_profile_id: '',
    lastAnonymousProfileId: '',
    lastKnownProfileId: '',
    mvpd: '',
    network_entitlement_list: '',
    us_privacy: ''
};
// TODO: Update BRAND and DEVICE for Nation
// const DEVICE = account?.device ?? 'FOX';
var BRAND = FOX;
var DEVICE = 'FOX';
var defaultProps = {
    app_name: "fox" || 0,
    app_platform: APP_PLATFORM,
    // TODO: set app version dynamically
    app_version: '1.0.0',
    page_name: ACTIVATION_METHOD,
    page_profile_activation_method: ACTIVATION_METHOD,
    page_start_source: START_SOURCE,
    page_type: PAGE_TYPE,
    primary_business_unit: PRIMARY_BUSINESS_UNIT,
    secondary_business_unit: "fox" || 0
};
var handleTrackEvent = function() {
    for(var _len = arguments.length, events = new Array(_len), _key = 0; _key < _len; _key++){
        events[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _step.value, eventName = _value.eventName, props = _value.props, context = _value.context, eventType = _value.eventType;
            var ref, ref1;
            var cookies = new Cookies/* default */.Z();
            var ref2;
            var profileId = (ref2 = cookies.get(PROFILE_ID_COOKIE)) !== null && ref2 !== void 0 ? ref2 : '';
            var ref3;
            var codeInfoCookie = (ref3 = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref3 !== void 0 ? ref3 : {};
            var campaignCodes = fetchCampaignCodes();
            // TODO: Find out why campaignCodes are different for different events
            if (eventName === Events.PROFILE_ACCESS_ACTIVATION_COMPLETED) {
                var ref4;
                var compaignCodesCookie = (ref4 = cookies.get(constants/* COOKIE_CAMPAIGN_CODES */.gV)) !== null && ref4 !== void 0 ? ref4 : '';
                campaignCodes = parseCampaignParams(compaignCodesCookie);
            }
            var traits = _objectSpread({}, defaultTraits, campaignCodes, {
                dcg_profile_id: profileId,
                lastAnonymousProfileId: getAnonymousId(),
                lastKnownProfileId: profileId
            });
            var ref5;
            var argsPageName = (ref5 = props === null || props === void 0 ? void 0 : props.page_name) !== null && ref5 !== void 0 ? ref5 : null;
            var ref6;
            var currentPageName = (ref6 = (ref = window.DataLayer) === null || ref === void 0 ? void 0 : ref.page_name) !== null && ref6 !== void 0 ? ref6 : null;
            var pageName = argsPageName !== null && argsPageName !== void 0 ? argsPageName : currentPageName;
            var genericPageName = generatePageName({
                pageName: pageName
            });
            var ref7;
            var argsPageType = (ref7 = props === null || props === void 0 ? void 0 : props.page_type) !== null && ref7 !== void 0 ? ref7 : null;
            var ref8;
            var currentPageType = (ref8 = (ref1 = window.DataLayer) === null || ref1 === void 0 ? void 0 : ref1.page_type) !== null && ref8 !== void 0 ? ref8 : null;
            var pageType = argsPageType !== null && argsPageType !== void 0 ? argsPageType : currentPageType;
            var ref9;
            var argsActivationCode = (ref9 = props === null || props === void 0 ? void 0 : props.page_activation_code) !== null && ref9 !== void 0 ? ref9 : null;
            var _code;
            var currentActiovationCode = (_code = codeInfoCookie.code) !== null && _code !== void 0 ? _code : null;
            var activationCode = argsActivationCode !== null && argsActivationCode !== void 0 ? argsActivationCode : currentActiovationCode;
            var newContext = _objectSpread({}, context, {
                traits: traits
            });
            var finalProps = (0,helper.cleanObject)(_objectSpread({}, defaultProps, {
                page_name: genericPageName,
                page_type: pageType,
                page_activation_code: activationCode
            }, props));
            handleAnalytics({
                eventName: eventName,
                props: finalProps,
                eventType: eventType,
                context: newContext
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var generatePageName = function(param) {
    var pageName = param.pageName;
    return "".concat(APP_CLIENT_PREFIX, ":").concat(APP_PLATFORM, ":").concat(pageName);
};
var handleHomePageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_ACCESS_ACTIVATION_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_LANDING,
        eventType: EventTypes.PAGE
    });
};
var handleAccountPageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_PROMPT_LANDING,
        eventType: EventTypes.PAGE
    });
};
var getAnonymousId = function() {
    var ref;
    var cookies = new Cookies/* default */.Z();
    var user = (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.user;
    var ref10;
    var lastAnonymousProfileId = (ref10 = cookies.get(ANONYMOUS_ID_COOKIE)) !== null && ref10 !== void 0 ? ref10 : '';
    var networkDomain;
    if (BRAND === FOX) networkDomain = FOX_DOMAIN;
    else networkDomain = NATION_DOMAIN;
    if (lastAnonymousProfileId) {
        cookies.set(ANONYMOUS_ID_COOKIE, lastAnonymousProfileId, {
            domain: networkDomain
        });
        return lastAnonymousProfileId;
    }
    var anonymousId = user ? user().anonymousId() : null;
    // TODO: Finds out why it is here
    cookies.set(ANONYMOUS_ID_COOKIE, anonymousId, {
        domain: networkDomain
    });
    return anonymousId;
};
var mountDataLayer = function() {
    window.DataLayer = {};
};
var setPageAnalyticsData = function(param) {
    var pageName = param.pageName, pageType = param.pageType;
    if (!window.DataLayer) mountDataLayer();
    window.DataLayer.page_name = pageName;
    window.DataLayer.page_type = pageType;
};
var parseCampaignParams = function(queryString) {
    if (!queryString) return {};
    var cleanQueryString = queryString.split('undefinedUnknown')[0];
    var segmentCampaign = 'cmpid';
    var propertyNames = {
        cmpid: 'campaign_int_tracking_code',
        int_cmp: 'campaign_int_name'
    };
    var params = {};
    var ref13;
    var cleanCampaignString = (ref13 = cleanQueryString.match(/^[^&]*/)) !== null && ref13 !== void 0 ? ref13 : '';
    var ref11;
    var campaignString = (ref11 = cleanCampaignString[0]) !== null && ref11 !== void 0 ? ref11 : '';
    params[propertyNames[segmentCampaign]] = campaignString;
    var campaignCodes = campaignString.split('::');
    (campaignCodes || []).forEach(function(codes) {
        var keyValuesPair = codes.split('=');
        if (keyValuesPair.length === 2) {
            var ref;
            var key = (ref = keyValuesPair[0]) !== null && ref !== void 0 ? ref : '';
            var ref12;
            var value = (ref12 = keyValuesPair[1]) !== null && ref12 !== void 0 ? ref12 : '';
            var _key;
            var property = (_key = propertyNames[key]) !== null && _key !== void 0 ? _key : '';
            params[property] = value;
        }
    });
    return (0,helper.cleanObject)(params);
};
var fetchCampaignCodes = function() {
    var ref;
    var intCmp = (ref = getParameterByName(constants/* INT_CMP */.vl)) !== null && ref !== void 0 ? ref : null;
    // if (intCmp == null) return null;
    var intOrg = 'dcg';
    // TODO: Get brand from
    var intMc = BRAND;
    var ref14;
    var intSrc = (ref14 = getDeviceFromProvidersByKey()) !== null && ref14 !== void 0 ? ref14 : DEVICE;
    var intAdd = intMc + (intSrc ? '_' + intSrc : '') + (intCmp ? '_' + intCmp : '');
    var codes = (0,helper.cleanObject)({
        int_org: intOrg,
        int_mc: intMc !== null && intMc !== void 0 ? intMc : null,
        int_src: intSrc !== null && intSrc !== void 0 ? intSrc : null,
        int_cmp: intCmp !== null && intCmp !== void 0 ? intCmp : null,
        int_add: intAdd !== null && intAdd !== void 0 ? intAdd : null
    });
    codes.campaign_int_tracking_code = formatCampaignString(codes);
    return codes;
};
var getParameterByName = function getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window === null || window === void 0 ? void 0 : window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};
var formatCampaignString = function(campaignCodes) {
    var campaignKeys = Object.keys(campaignCodes);
    return campaignKeys.reduce(function(acc, key, i) {
        var isLast = i === campaignKeys.length - 1;
        return acc + key + '=' + campaignCodes[key] + (!isLast ? '::' : '');
    }, '');
};
var getDeviceFromProvidersByKey = function() {
    var cookies = new Cookies/* default */.Z();
    var ref;
    var codeInfoCookie = (ref = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref !== void 0 ? ref : '';
    var config = (0,getConfig/* getConfig */.i)();
    var ref15;
    var devices = (ref15 = config === null || config === void 0 ? void 0 : config.devices) !== null && ref15 !== void 0 ? ref15 : [];
    Object.entries(devices).forEach(function(element) {
        var deviceName = element[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var providerKeys = element[1]['providers-key'];
        if (providerKeys === codeInfoCookie || deviceName === providerKeys) return element;
    });
    return null;
};


/***/ }),

/***/ 3017:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvRG93bmxvYWRzL0FjdGlvbnMvRG93bmxvYWQgRXJyb3IvMTg8L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zL0Rvd25sb2Fkcy9BY3Rpb25zL0Rvd25sb2FkLUVycm9yLzE4IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNOSwwIEMxMy45NzA1NjI3LDAgMTgsNC4wMjk0MzcyNSAxOCw5IEMxOCwxMy45NzA1NjI3IDEzLjk3MDU2MjcsMTggOSwxOCBDNC4wMjk0MzcyNSwxOCAwLDEzLjk3MDU2MjcgMCw5IEMwLDQuMDI5NDM3MjUgNC4wMjk0MzcyNSwwIDksMCBaIE05LDEuMjUgQzQuNzE5NzkzMTksMS4yNSAxLjI1LDQuNzE5NzkzMTkgMS4yNSw5IEMxLjI1LDEzLjI4MDIwNjggNC43MTk3OTMxOSwxNi43NSA5LDE2Ljc1IEMxMy4yODAyMDY4LDE2Ljc1IDE2Ljc1LDEzLjI4MDIwNjggMTYuNzUsOSBDMTYuNzUsNC43MTk3OTMxOSAxMy4yODAyMDY4LDEuMjUgOSwxLjI1IFogTTEwLDEyIEwxMCwxNCBMOCwxNCBMOCwxMiBMMTAsMTIgWiBNMTAsNCBMMTAsMTEgTDgsMTEgTDgsNCBMMTAsNCBaIiBpZD0iRXJyb3IiIGZpbGw9IiNmZmZmZmYiPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ })

}]);